export const ADMIN = "administrator";
export const LEGAL_REPRESENTATIVE = "LegalRepresentative";
